export default {
  roundOnly: true,
  checkoutFormVariant: 'd',
  planSet: 'pricing-23',
  growthbookFeatures: ['supp', 'thankyou_tips'],
};
